<template>
  <div class="view"
    @click="clickHandle"
  >
    <!-- <div class="de-bug-view">
      {{ width }}:{{ height }}
    </div> -->
    <router-view/>
    <fullScreenLoadingView></fullScreenLoadingView>
    <logsView></logsView>
  </div>
</template>

<script>
import fullScreenLoadingView from '@/views/public/fullScreenLoadingView.vue'
import ApiService from '@/assets/js/apiService'
const api = new ApiService()
import shareds from '@/assets/js/shared';
const shared = new shareds()
import Router from '@/assets/js/Router';
const router = Router.getInstance();
import logsView from '@/views/public/logsView.vue'
export default {
  name: 'App',
  data(){
    return {
      width:0,
      height:0,
      loopState: null,
      debugClickCount: 0,
      debugClickTimer: null
    }
  },
  components: {fullScreenLoadingView , logsView},
  watch:{},
  computed:{},
  methods:{
    clickHandle() {
      console.log("clickHandle debug mode off");
      return;
      // 如果已有定時器，先清掉
      if (this.debugClickTimer) {
        clearTimeout(this.debugClickTimer)
      }

      this.debugClickCount++

      // 若連點超過 20 次，觸發 logsView
      if (this.debugClickCount >= 20) {
        this.$store.commit('SET_LOGS_VIEW', true)  // 用 mutation 設定 logsView
        this.debugClickCount = 0  // 重置
        return
      }

      // 設定2秒內沒繼續點就歸零
      this.debugClickTimer = setTimeout(() => {
        this.debugClickCount = 0
      }, 2000)
    }
  },
  beforeUnmount(){
    //清除計時器
    clearInterval(this.loopState)
    this.loopState = null
  },
  async mounted(){

    router.setRouter(this.$router);

    this.loopState = setInterval( async function(){
      let trainingRecord = JSON.parse(localStorage.getItem('trainingRecord')) || [];
      if(trainingRecord.length>0){
        // alert(`api.setTrainingRecords`)
        let res = await api.setTrainingRecords(trainingRecord[0]);
        console.log('setTrainingRecords:' ,res);
        if( res.code==10000 ){
          trainingRecord = JSON.parse(localStorage.getItem('trainingRecord')) || [];
          trainingRecord.splice(0, 1);
          localStorage.setItem('trainingRecord',JSON.stringify(trainingRecord));
        }
      }
    }, 3000)//60000)

  },
  async created(){

    this.width = window.innerWidth;
    this.height = window.innerHeight;

    const self = this
    //檢查當日遊玩紀錄
    // 取得 localStorage 中的資料
    shared.initLocalStorageData()
    window.addEventListener('load', function () {
      function isPortrait() {
        return window.matchMedia("(orientation: portrait)").matches;
      }

      function showPortraitAlert() {
        alert(self.$t("orientation_portrait"));
      }

      if (isPortrait()) {
        showPortraitAlert();
      }

      window.addEventListener('orientationchange', function () {
        if (!isPortrait()) {
          showPortraitAlert();
        }
      });
    });

    this.mParam = this.$route.query.m; // 獲取URL中的 m 參數的值
    console.log("mParam=>",this.mParam)

  }
}
</script>
<style scoped>
.full-screen{
    width: 100dvw;
    height: 100dvh;
}
.view{
  position: relative;
}
.de-bug-view{
  position: fixed;
  right: 10px;
  bottom: 10px;
  color: #d3d3d3;
}
</style>
